export const EVENTS = {
  REBUY_CART_ADD: 'rebuy:cart.add',
  OPEN: 'cart:open',
  UPDATED: 'cart:updated',
  ITEM_ADDED:'cart:ITEM:added',
};

export const ACTIONS = {
  CHANGE_QUANTITY: 'changeQuantityAction',
  ADD_PRODUCT: 'addProductAction',
  UPDATE_LINE_ITEM_SUBSCRIPTION: 'updateLineItemSubscription',
  CHANGE_LINE_ITEM: 'changeLineItem',
  DISCOUNT_CALCULATED: 'discountCalculated',
};
